<script>

    import { replace } from 'svelte-spa-router'
    import { adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import View from '../$layouts/view.layout.svelte'
    import PageHeader from '../$components/page.header.svelte'
    import Modal from '../$components/modal.container.svelte'

    import ChargesDownload from './component.charges.download.svelte'
    import ChargesComponent from './component.charges.svelte'
    import ChargeCreateComponent from './component.create.svelte'
    import ChargeComponent from './component.charge.svelte'
    import ChargeUpdateComponent from './component.update.svelte'

    if(!isPermission($adminStore, 'UsersView.Charges.View'))
        replace('/404')

</script>

<View>
    <PageHeader title="Cargos" subtitle="Cargos adicionales aplicados a usuarios" />
    <ChargesComponent all={true} type="charge" />
</View>

<Modal id="charges_download_modal" title="Descargar cargos" >
    <ChargesDownload />
</Modal>

<Modal id="charge_create_modal" title="Crear Cargo" >
    <ChargeCreateComponent />
</Modal>

<Modal id="charge_modal" title="Cargo" >
    <ChargeComponent />
</Modal>

<Modal id="charge_update_modal" title="Actualizar cargo" >
    <ChargeUpdateComponent />
</Modal>
